import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { DynamicItem } from 'src/app/main/dynamic/dynamic-item';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';


@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss']
})
export class RadioComponent extends ComponentBase implements OnInit {

  constructor() {
    super()
  }

  get isPlaceholder(): boolean {
    return !this.attribute.value
  }

  get isStrong(): boolean {
    let textDecoration = this.getOptionByKey(this.attribute, "textdecoration");

    if(textDecoration == "bold") {
      return true;
    } else {
      textDecoration = this.envOptions.find(opt => opt.key.toLowerCase() == "textdecoration" &&
                                                   opt.value.toLowerCase() == "bold")?.value
      return textDecoration == "bold";
    }
  }

  get isValid(): boolean {
    let requiredOpt = this.getOptionByKey(this.attribute, "required")

    if(!requiredOpt) {
      return false;
    }

    if(requiredOpt.toLowerCase() == "true" &&
        !this.attribute.value) {
      return false
    }

    return true
  }

  ngOnInit() {
    if(!this.attribute.value) {
      this.attribute.value = null
    }
  }

  getOptionByKey(attribute: AttributeModel, key: string): string {

    if (!attribute.options)
      return "";

    let opt = attribute.options.find(option => option.key == key);

    if (opt)
      return opt.value;
    else
      return "";
  }

  getAvailableAttributes(): AttributeModel[] {
    return this.attribute.attributes.filter(attr => {
      let showOpt = attr.options.find(opt => opt.key.toLowerCase() == "show" &&
                                             opt.type.toLowerCase() == "boolean")

      if(showOpt) {
        return showOpt.value.toLowerCase() == "true"
      }

      return true
    })
  }

  getValue(): string {
    return this.attribute.value;
  }

  isChecked(option: AttributeModel): boolean {
    if(!this.attribute.value) {
      return false;
    }

    let checkedOpt = this.attribute.attributes
      .find(attr => attr.value.toLowerCase() == this.attribute.value.toLowerCase());

    if(checkedOpt) {
      return checkedOpt.key == option.key;
    }

    return false;
  }

  onValueChange(value: any) {
    let events: DynamicEvent[] = []

    let selected = this.attribute.attributes
      .find(attr => attr.key == value.target.value);

    if(selected) {
      this.attribute.value = selected.value;
      events.push({ attribute: selected });
    } else {
      this.attribute.value = null;
    }

    this.validate(events);

    events.push({ name: "autosave", data: "silently" });

    this.emitEvents(events);
  }

  private validate(events: DynamicEvent[]) {
    if (this.attribute.hasError && this.attribute.value) {
      this.attribute.hasError = false;
      events.push({ name: "validate" });
    }
  }
}
